/**
 * A Dashboard telefonos (<600 px) elrendezésének közös mérete [Web UX 9 / T3, 2026-10-13].
 *
 * Telefonon a Dashboard a lap tartalmát egy SAJÁT görgető dobozba teszi (`Dashboard.tsx`,
 * `height: 100dvh` + `overflowY: 'auto'`), alatta a folyamban az alsó menü (`MobileBottomNav`).
 * A doboz alsó belső margója ez a konstans (MUI spacing-egység).
 *
 * MIÉRT KÖZÖS: a jelenléti ív rögzített mentés-sávja (`EventAttendance.tsx` `renderSaveBar`) ebben a
 * dobozban `position: sticky; bottom`-mal tapad a menü fölé, és a Chromium a sticky-határt a görgető
 * doboz belső margóján BELÜL számolja — MÉRVE (Playwright 390/360 px): `bottom: 0` mellett a sáv és a
 * menü között 16 px rés maradt, amin át a lista tartalma kilátszott. A sáv ezért pontosan ennyivel
 * lóg lejjebb; ha valaki a Dashboard margóját átírja, a sáv vele mozog (nem bűvös szám).
 */
export const MOBILE_SCROLLER_PADDING_BOTTOM = 2;

/**
 * A görgető doboz oldalsó belső margója telefonon (MUI spacing) [Web UX 9 / T3, 2026-10-13, validátor M1].
 * A jelenléti ív sticky mentés-sávja ennyivel (+ a saját gyökere margójával) lóg ki oldalra, hogy a
 * képernyő szélétől szélig érjen — ha valaki a Dashboard margóját átírja, a sáv vele mozog.
 */
export const MOBILE_SCROLLER_PADDING_X = 1;
